import {useSelector} from 'react-redux';
import {themeSelector} from '../../../redux/selectors/runtime/theme';
import {VisImpSwitchImage, VisImpStatus} from '../../models/visuallyImpairedSettings';
import {useCallback, useState} from 'react';
import {LayoutChangeEvent} from 'react-native';

export const useImageSettings = (important?: boolean) => {
  const {switchImages, visuallyImpaired} = useSelector(themeSelector());
  return {
    hideImage: visuallyImpaired === VisImpStatus.Active && !important && switchImages === VisImpSwitchImage.False,
    offColor: visuallyImpaired === VisImpStatus.Active,
  };
};

export const useImageSize = () => {
  const [[width, height], setSize] = useState([0, 0]);
  const handleLayout = useCallback(
    (event: LayoutChangeEvent) => {
      const {layout} = event.nativeEvent;
      if (layout.width !== width || layout.height !== height) {
        setSize([layout.width, layout.height]);
      }
    },
    [width, height],
  );

  return {
    width,
    height,
    handleLayout,
  };
};
